exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".recipes .list>div>.list-item{min-height:80px}.recipe .list-item{padding:30px 0;height:25vh;display:flex;align-items:flex-end}.recipe .list-item h3{margin:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"id":"data-v-1148d724","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/RecipesStart.vue
// module id = 72
// module chunks = 0